<div class="flow-checkbox">
    <label [class.checked]="checked">
        <span class="checkbox-container">
            <input
                    [checked]="checked"
                    [disabled]="disabled"
                    type="checkbox"
                    (blur)="onBlur($event)"
                    (change)="handleChange($event)">
            <span class="checkbox-control">
                <ion-icon name="checkmark-outline"></ion-icon>
            </span>
        </span>

        <span class="checkbox-label"><ng-content></ng-content></span>
    </label>
</div>
